<template>

  <q-dialog v-model="confirm" persistent>
    <q-card>
      <q-card-section class="row items-center">
        <q-avatar icon="logout" color="primary" text-color="white" />
        <span class="q-ml-sm">Are you sure?</span>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="Cancel" color="negative" v-close-popup />
        <q-btn flat label="Logout" color="purple" v-close-popup @click="userLogout" />
      </q-card-actions>
    </q-card>
  </q-dialog>
  

  <q-layout view="lHh Lpr lFf" class="shadow-2 rounded-borders">
    <q-header class="appHeader" bordered v-if="!['login-user'].includes($route.name)">
      <q-toolbar>
        <q-btn
          flat
          dense
          round
          @click="leftDrawerOpen = !leftDrawerOpen"
          aria-label="Menu"
          icon="menu"
        />

        
        <div class="userInfo">

          <ul class="buttons">
            <li class="pricing">
              <span>
                <a href="#" class="link-pricing" @click="$router.replace('/pricing')" icon-right="price_change">Pricing</a>
              </span>
            </li>
            <!-- <li>payment type {{ paymentType }}</li> -->
            <li class="balance">
              <span>
                <span>{{ balanceLabel }}: {{ balance }} EUR</span>
              </span>
            </li>

            <li class="welcome" v-if="isLoggedIn">
              <span>
                User: <span class="user">{{username}}</span> 
              </span>
            </li>

            <li class="user">
              <span v-if="isLoggedIn">
                <a href="#" @click="confirm = true" icon-right="logout">Logout</a>
              </span>
              <span v-else>
                <a href="#" @click="$router.replace('/login')" icon-right="person">Login</a>
              </span>
            </li>
          </ul>

          

        </div>
      </q-toolbar>
    </q-header>
    

    <q-drawer v-if="!['login-user'].includes($route.name)"
      v-model="leftDrawerOpen"
      show-if-above
      class="bg-white-2"
    >
      
      <q-list class="rounded-borders appList">

        <q-item-label header class="img-logo-header">
          <img class="img-logo-dash" src="./assets/altmedia-dash.png" alt="">
        </q-item-label>
        
        <q-item active-class="tab-active" clickable tag="a" to="/">
          <q-item-section avatar>
            <q-icon name="home" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Dashboard</q-item-label>
          </q-item-section>
        </q-item>
       



        <q-expansion-item  v-model="$store.state.isExpansionReportsOpen" :content-inset-level="0.5" icon="code" label="Reports">

          <q-item active-class="tab-active" clickable tag="a" to="/reports-campaigns">
          <q-item-section avatar>
            <q-icon name="campaign" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Campaigns</q-item-label>
          </q-item-section>
        </q-item>

          <q-item active-class="tab-active" clickable tag="a" to="/reports-edr">
          <q-item-section avatar>
            <q-icon name="receipt" />
          </q-item-section>
          <q-item-section>
            <q-item-label>EDR</q-item-label>
            <q-item-label caption>SMS detailed records</q-item-label>
          </q-item-section>
        </q-item>
        <q-item active-class="tab-active" clickable tag="a" to="/reports-sms-usage-stats">
          <q-item-section avatar>
            <q-icon name="sms" />
          </q-item-section>
          <q-item-section>
            <q-item-label>SMS Usage</q-item-label>
          </q-item-section>
        </q-item>
      </q-expansion-item>

















      <q-expansion-item
        v-if="paymentType === 'prepay'"
        v-model="$store.state.isExpansionBillingOpen"
        :content-inset-level="0.5"
        icon="receipt_long"
        label="Billing"
      >
        <q-item active-class="tab-active" clickable tag="a" to="/invoices">
          <q-item-section avatar>
            <q-icon name="calculate" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Invoices</q-item-label>
          </q-item-section>
        </q-item>

        <q-item active-class="tab-active" clickable tag="a" to="/payments">
          <q-item-section avatar>
            <q-icon name="local_atm" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Payments</q-item-label>
          </q-item-section>
        </q-item>
      </q-expansion-item>




      <q-item active-class="tab-active" clickable tag="a" to="/sender">
          <q-item-section avatar>
            <q-icon name="phone" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Sender ID</q-item-label>
          </q-item-section>
      </q-item>
















      <q-item active-class="tab-active" clickable tag="a" to="/contact-groups">
          <q-item-section avatar>
            <q-icon name="groups" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Contact Groups</q-item-label>
          </q-item-section>
      </q-item>

      <q-expansion-item  v-model="$store.state.isExpansionTemplatesOpen" :content-inset-level="0.5" icon="code" label="Templates">
          <q-item active-class="tab-active" clickable tag="a" to="/templates-sms">
          <q-item-section avatar>
            <q-icon name="sms" />
          </q-item-section>
          <q-item-section>
            <q-item-label>SMS Templates</q-item-label>
          </q-item-section>
        </q-item>
      </q-expansion-item>

      <q-item active-class="tab-active" clickable tag="a" to="/blacklist">
          <q-item-section avatar>
            <q-icon name="cancel" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Blacklist</q-item-label>
          </q-item-section>
      </q-item>

      <q-expansion-item v-model="$store.state.isExpansionSmsOpen" :content-inset-level="0.5" icon="code" label="SMS">
          <q-item active-class="tab-active" clickable tag="a" to="/sms-campaign-builder">
          <q-item-section avatar>
            <q-icon name="campaign" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Campaign Builder</q-item-label>
          </q-item-section>
        </q-item>
        <q-item active-class="tab-active" clickable tag="a" to="/sms-quick-send">
          <q-item-section avatar>
            <q-icon name="send" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Quick Send</q-item-label>
          </q-item-section>
        </q-item>
      </q-expansion-item>

    </q-list>
    </q-drawer>

    <q-page-container>
      <router-view />
    </q-page-container>
  </q-layout>
</template>

<script>
import { getRestEndpoint } from '@/utils/utils'
import { handleClientTokenExpiration, handleTokenExpiration } from '@/utils/auth';
import { ref } from 'vue'
import axios from "axios";
import { isLoggedIn, logoutUser, getUserDetails, getAuthToken } from './utils/auth';

export default {
  name: 'LayoutDefault',
  data () {
    return {
      REST_ENDPOINT: '',
      username: '',
      token: '',
      balance: '',
      balanceLabel: '',
      paymentType: '',
      balanceStartDate: '',
      balanceEndDate: '',
      isLoggedIn: false,
    };
  },
  created() {
    handleClientTokenExpiration(this.$router);
  },
  methods: {
    userLogout() {
      this.balance = '';
      this.balanceLabel = '';
      localStorage.removeItem('userBalance');
      localStorage.removeItem('userBalanceLabel');
      logoutUser();
      this.$router.push('/login')
    },

    

    getBalanceFromAPI() {
      if (this.isLoggedIn) {
        axios.post(`${this.REST_ENDPOINT}reports/balance`, {
          startDate: this.balanceStartDate,
          endDate: this.balanceEndDate
        }, { withCredentials: true })
          .then((response) => {
            const formatter = new Intl.NumberFormat('en-US');
            this.balance = formatter.format(response.data.balance);
            this.balanceLabel = response.data.balanceLabel;
            localStorage.setItem('userBalance', this.balance);
            localStorage.setItem('userBalanceLabel', this.balanceLabel);
          })
          .catch(error => {
            if (error.response && error.response.status === 401 && error.response.data === 'Token expired') {
              handleTokenExpiration(this.$router);
            }
          });
      }
    },

    getPaymentTypeFromAPI() {
      if (this.isLoggedIn) {
        axios.post(`${this.REST_ENDPOINT}reports/payment-type`, {}, { withCredentials: true })
          .then((response) => {
            this.paymentType = response.data.paymentType;
            localStorage.setItem('paymentType', this.paymentType);
          })
          .catch(error => {
            if (error.response && error.response.status === 401 && error.response.data === 'Token expired') {
              handleTokenExpiration(this.$router);
            }
          });
      }
    },
  },
  mounted() {
    this.REST_ENDPOINT = getRestEndpoint();
    this.isLoggedIn = isLoggedIn();
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    this.balanceStartDate = `${year}.${month}.01`;
    this.balanceEndDate = `${year}.${month}.${day}`;
    this.token = getAuthToken();
    this.username = getUserDetails().username;
    const storedBalance = localStorage.getItem('userBalance');
    if (storedBalance) {
      this.balance = storedBalance;
    }
    const storedBalanceLabel = localStorage.getItem('userBalanceLabel');
    if (storedBalanceLabel) {
      this.balanceLabel = storedBalanceLabel;
    }
    const storedpaymentType = localStorage.getItem('paymentType');
    if (storedpaymentType) {
      this.paymentType = storedpaymentType;
    }
  },
  watch: {
    $route(to, from) {
      if (from.name === 'login-user') {
        this.username = getUserDetails().username;
        this.isLoggedIn = isLoggedIn();
        this.getBalanceFromAPI();
        this.getPaymentTypeFromAPI();
      }
    }
  },
  setup () {
    return {
      leftDrawerOpen: ref(false),
      confirm: ref(false),
      expanded: ref(false)
    }
  }
}
</script>

<style lang="scss">
@import './styles/styles.scss';

  // start drawer
  .img-logo-header {
    display: flex;

    .img-logo-dash {
      height: 50px;
      margin: 0 auto 5px;
      padding-right: 15px;
    }

  }  
  .appList {
    padding: 10px;
  }
  .q-layout__section--marginal {
    background-color: $altmedia-base-color !important;
  }
  .tab-active {
    background-color: $altmedia-base-color;
    border-radius: 5px;

    .q-item__label {
      color: #fff;
    }

    .q-item__section--avatar {
      color: #fff;
    }
  }
  // end drawer

  .appHeader {
    .userInfo {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      width: 100%;
      font-size: 15px;
      font-family: Montserrat,Helvetica,Arial,serif;

      .buttons {
        display: flex;
        list-style-type: none;

        li {
          margin-right: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 30px;
          border-right: 1px solid #fff;
          padding-right: 30px;

          a {
            text-decoration: none;
            color: #fff;
            cursor: pointer;
          }
        }

        .welcome {
          .user {
            font-weight: bold;
            text-decoration: underline;
          }
        }
        li:last-child {
          border: none;
          margin-right: 10px;
          padding-right: 10px;
        }
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .appHeader {
      .userInfo {
        font-size: 13px;
        .buttons {
          li {
            margin-right: 10px;
            padding-right: 10px;
          }
          li:last-child {
            margin-right: 0px;
            padding-right: 0px;
          }
        }
      }
    }
  }

  
</style>
